import { useQuery } from "@tanstack/react-query";
import { agentsApi } from "@/api/agents";
import { queryKeys } from "@/lib/query-keys";

export function useAgentsByCompany(companyId: string) {
  return useQuery({
    queryKey: queryKeys.agents.byCompany(companyId),
    queryFn: () => agentsApi.listByCompany(companyId),
    enabled: !!companyId,
  });
}

export function useAgent(id: string) {
  return useQuery({
    queryKey: queryKeys.agents.detail(id),
    queryFn: () => agentsApi.get(id),
    enabled: !!id,
  });
}

export function useSubagents(parentAgentId: string) {
  return useQuery({
    queryKey: [...queryKeys.agents.detail(parentAgentId), "subagents"],
    queryFn: () => agentsApi.listSubagents(parentAgentId),
    enabled: !!parentAgentId,
  });
}
